(function() {
  var SHRUNK = '58px';
  var LOGO_SMALL = '42px';
  var LOGO_LARGE = '100px';
  var isCurrentlyShrunk = false;
  var ticking = false;
  var SHRINK_THRESHOLD = 150;
  var RESTORE_THRESHOLD = 10;

  function shrink(header) {
    if (isCurrentlyShrunk) return;
    isCurrentlyShrunk = true;

    var logo = header.querySelector('.header-logo__image');
    var logoContainer = header.querySelector('.header-logo__image-container');
    var headerLogo = header.querySelector('.header-logo');
    var leftCol = header.querySelector('.header__column--left');
    var rightCol = header.querySelector('.header__column--right');
    var columns = header.querySelector('.header__columns');
    var topRow = header.querySelector('.header__row--top');

    if (topRow) { topRow.style.height = SHRUNK; topRow.style.minHeight = SHRUNK; topRow.style.maxHeight = SHRUNK; topRow.style.overflow = 'visible'; }
    if (columns) { columns.style.height = SHRUNK; columns.style.minHeight = SHRUNK; columns.style.maxHeight = SHRUNK; columns.style.display = 'flex'; columns.style.alignItems = 'center'; columns.style.justifyContent = 'space-between'; columns.style.setProperty('--padding-block-start', '0px'); columns.style.setProperty('--padding-block-end', '0px'); columns.style.paddingTop = '0'; columns.style.paddingBottom = '0'; }
    if (leftCol) { leftCol.style.height = SHRUNK; leftCol.style.display = 'flex'; leftCol.style.alignItems = 'center'; }
    if (rightCol) { rightCol.style.height = SHRUNK; rightCol.style.display = 'flex'; rightCol.style.alignItems = 'center'; rightCol.style.justifyContent = 'flex-end'; }
    if (headerLogo) { headerLogo.style.height = LOGO_SMALL; headerLogo.style.display = 'flex'; headerLogo.style.alignItems = 'center'; headerLogo.style.setProperty('--padding-block-start', '0px'); headerLogo.style.setProperty('--padding-block-end', '0px'); }
    if (logoContainer) { logoContainer.style.height = LOGO_SMALL; logoContainer.style.width = LOGO_SMALL; logoContainer.style.overflow = 'hidden'; }
    if (logo) { logo.style.height = LOGO_SMALL; logo.style.width = 'auto'; logo.style.setProperty('--header-logo-image-height', LOGO_SMALL); logo.style.setProperty('--header-logo-image-width', LOGO_SMALL); }
    header.querySelectorAll('.menu-list__link').forEach(function(link) { link.style.height = SHRUNK; link.style.display = 'flex'; link.style.alignItems = 'center'; });
  }

  function restore(header) {
    if (!isCurrentlyShrunk) return;
    isCurrentlyShrunk = false;

    var logo = header.querySelector('.header-logo__image');
    var logoContainer = header.querySelector('.header-logo__image-container');
    var headerLogo = header.querySelector('.header-logo');
    var leftCol = header.querySelector('.header__column--left');
    var rightCol = header.querySelector('.header__column--right');
    var columns = header.querySelector('.header__columns');
    var topRow = header.querySelector('.header__row--top');

    if (topRow) { topRow.style.height = ''; topRow.style.minHeight = ''; topRow.style.maxHeight = ''; topRow.style.overflow = ''; }
    if (columns) { columns.style.height = ''; columns.style.minHeight = ''; columns.style.maxHeight = ''; columns.style.display = ''; columns.style.alignItems = ''; columns.style.justifyContent = ''; columns.style.paddingTop = ''; columns.style.paddingBottom = ''; columns.style.setProperty('--padding-block-start', ''); columns.style.setProperty('--padding-block-end', ''); }
    if (leftCol) { leftCol.style.height = ''; leftCol.style.display = ''; leftCol.style.alignItems = ''; }
    if (rightCol) { rightCol.style.height = ''; rightCol.style.display = ''; rightCol.style.alignItems = ''; rightCol.style.justifyContent = ''; }
    if (headerLogo) { headerLogo.style.height = ''; headerLogo.style.display = ''; headerLogo.style.alignItems = ''; headerLogo.style.setProperty('--padding-block-start', ''); headerLogo.style.setProperty('--padding-block-end', ''); }
    if (logoContainer) { logoContainer.style.height = ''; logoContainer.style.width = ''; logoContainer.style.overflow = ''; }
    if (logo) { logo.style.height = LOGO_LARGE; logo.style.width = 'auto'; logo.style.setProperty('--header-logo-image-height', LOGO_LARGE); logo.style.setProperty('--header-logo-image-width', LOGO_LARGE); }
    header.querySelectorAll('.menu-list__link').forEach(function(link) { link.style.height = ''; link.style.display = ''; link.style.alignItems = ''; });
  }

  var header = document.getElementById('header-component');
  if (!header) return;

  window.addEventListener('scroll', function() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function() {
      var scrollY = window.scrollY;
      if (scrollY > SHRINK_THRESHOLD && !isCurrentlyShrunk) {
        shrink(header);
      } else if (scrollY < RESTORE_THRESHOLD && isCurrentlyShrunk) {
        restore(header);
      }
      ticking = false;
    });
  }, { passive: true });
})();